import React from "react";

/**
 * See also index.html loader
 */
export default function StaticLoader() {
  return (
    <div id="staticloader">
      <div className="circle" />
      <div className="circle" />
      <div className="circle" />
      <div className="circle" />
      <div className="circle" />
    </div>
  );
}
